import { formatNumberMix } from '@/utils'
export default {
  data() { },
  methods: {
    setCountList(data) {
      let list = new Array(4).fill(null)
      list[0] = {
        title: this.$t('work-order::user_title'),
        count: data && this.$dataCheck(formatNumberMix(data.userNum, 0, ',')),
        lastCount: data && this.$dataCheck(formatNumberMix(data.lastUserNum, 0, ',')),
        statisticsDays: data && data.statisticsDays,
        down: data && data.userNumRatio ? data.userNumRatio < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.userNumRatio, 2)),
        tooltip: this.$t('work-order::user_tooltip')
      }
      list[1] = {
        title: this.$t('work-order::recieve_title'),
        count: data && this.$dataCheck(formatNumberMix(data.emailNum, 0, ',')),
        lastCount: data && this.$dataCheck(formatNumberMix(data.lastEmailNum, 0, ',')),
        statisticsDays: data && data.statisticsDays,
        down: data && data.emailNumRatio ? data.emailNumRatio < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.emailNumRatio, 2)),
        tooltip: this.$t('work-order::recieve_tooltip')
      }
      list[2] = {
        title: this.$t('work-order::notReply_title'),
        count: data && this.$dataCheck(formatNumberMix(data.unresponseNum, 0, ',')),
        lastCount: data && this.$dataCheck(formatNumberMix(data.lastUnresponseNum, 0, ',')),
        statisticsDays: data && data.statisticsDays,
        down: data && data.unresponseNumRatio ? data.unresponseNumRatio < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.unresponseNumRatio, 2)),
        tooltip: this.$t('work-order::notReply_tooltip')
      }
      list[3] = {
        title: this.$t('work-order::notRecieve_title'),
        count: data && this.$dataCheck(formatNumberMix(data.unresponseRate, 2, ',')),
        lastCount: data && this.$dataCheck(formatNumberMix(data.lastUnresponseRate, 2, ',')),
        statisticsDays: data && data.statisticsDays,
        down: data && data.unresponseRateRatio ? data.unresponseRateRatio < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.unresponseRateRatio, 2)),
        suffix: '%',
        tooltip: this.$t('work-order::notRecieve_tooltip')
      }
      return list
    },
    setAcceptEmailConfig(data = []) {
      return {
        type: 'line',
        title: this.$t('work-order::recieveEmail_title'),
        ref: 'lineChart',
        height: '325px',
        chart: {
          xAxis: {
            data: data.map(item => item.date)
          },
          yAxis: [
            {
              type: 'value',
              splitLine: {
                lineStyle: {
                  color: '#DCDFE6',
                  type: 'dashed'
                }
              },
              min: 0,
              axisLabel: {
                margin: 16,
                color: '#9DA1C3'
              }
            },
            {
              type: 'value',
              min: 0,
              splitLine: {
                show: false
              },
              axisLabel: {
                margin: 16,
                color: '#9DA1C3',
                formatter: '{value} %'
              }
            }
          ],
          series: [
            {
              name: this.$t('work-order::recieveEmail_title'),
              type: 'line',
              data: data.map(item => Number(item.emailNum))
            }
          ]
        }
      }
    },
    setEmailTypeConfig(data = []) {
      return {
        type: 'ring',
        title: this.$t('work-order::emailType_title'),
        ref: 'ringChartSale',
        height: '305px',
        chart: {
          tooltip: {
            trigger: 'item',
            formatter: (params, ticket, callback) => {
              return `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color}"></span><span>${params.name}  </span><span style="font-weight:900;">${params.value}</span><br/>
                          <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;"></span><span>${params.name}  </span><span style="font-weight:900;">${params.data.rate}%</span>`
            }
          },
          series: [
            {
              type: 'pie',
              radius: '50%',
              label: {
                show: false
              },
              emphasis: {
                label: {
                  show: false
                }
              },
              labelLine: {
                show: false
              },
              data: [
                ...data.map(item => {
                  return {
                    value: item.emailNum,
                    rate: item.emailNumRate,
                    name: item.emailType
                  }
                })
              ]
            }
          ]
        }
      }
    },
    setReplierConfig(data = []) {
      return {
        title: '',
        ref: 'repliertable',
        height: '305px',
        cancelShadow: true,
        tableData: data
      }
    }
  }
}
